"use client";
import { FormattedMessage } from "react-intl";
import FooterCategoryName from "./FooterCategoryName";
import FooterLink from "./FooterLink";
import FooterLinkWrapper from "./FooterLinkWrapper";
import Link from "next/link";
import { useTranslationFooter } from "./Footer.hooks";
import { useContext } from "react";
import appCurrentLangContext from "@/contexts/appCurrentLang.context";
import { ARTICLES_TO_DISPLAY } from "@/modules/directus/directus.const";
import Copyright from "./Copyright";
import { calendlyUrl } from "@/modules/sales/sales.consts";
import LinkedInIcon from "@/assets/icons/linkedin.svg";
import EmailIcon from "@/assets/icons/email.svg";
import YouTubeIcon from "@/assets/icons/youtube.svg";

const Footer = () => {
  const {
    generalTranslation,
    pricingTranslation,
    termsAndConditionsTranslation,
    documentationTranslation,
    contactUsTranslation,
    emailUsTranslation,
  } = useTranslationFooter();

  const { appCurrentLang, setAppCurrentLang } = useContext(
    appCurrentLangContext,
  );

  return (
    <div className={`py-16 border-t border-gray-200 mt-20`}>
      <div className={`max-w-[80%] mx-auto `}>
        <div className="flex flex-col lg:flex-row items-start">
          {/* <div className={`w-1/4 mb-8 lg:mb-0`}>
            <FooterCategoryName
              defaultMessage="General"
              id="footer.tab.title.general"
            />
            <FooterLinkWrapper>
              <FooterLink name="© Rights" />
            </FooterLinkWrapper>
          </div> */}
          <div className={`w-1/4 mb-8 lg:mb-0 mt-6`}>
            <FooterCategoryName
              defaultMessage="About"
              id="footer.tab.title.about"
            />
            <FooterLinkWrapper>
              <Link href={"/"}>
                <FooterLink name={generalTranslation} />
              </Link>
              <Link href={"/pricing"}>
                <FooterLink name={pricingTranslation} />
              </Link>
            </FooterLinkWrapper>
            {/* <FooterLinkWrapper>
              <Link href={"/"}>
                <FooterLink name={generalTranslation} />
              </Link>
            </FooterLinkWrapper> */}
            <FooterLinkWrapper>
              <Link href={calendlyUrl} target="_blank">
                <FooterLink name={contactUsTranslation} />
              </Link>
            </FooterLinkWrapper>
          </div>
          <div className={`w-1/4 mb-8 lg:mb-0 mt-6`}>
            <FooterCategoryName
              defaultMessage={"Legal"}
              id="footer.tab.title.legal"
            />
            <FooterLinkWrapper>
              <Link href={"/termsAndConditions"}>
                <FooterLink name={termsAndConditionsTranslation} />
              </Link>
              <Link href={"/documentation"}>
                <FooterLink name={documentationTranslation} />
              </Link>
              {/* <FooterLink name="Autre" /> */}
            </FooterLinkWrapper>
          </div>
          <div className={`w-1/4 mb-8 lg:mb-0 mt-6`}>
            <FooterCategoryName
              defaultMessage="Social"
              id="footer.tab.title.social"
            />
            <FooterLinkWrapper>
              <Link
                href="https://www.youtube.com/@chatsystem_ai"
                target="_blank"
                rel="noreferrer"
              >
                <FooterLink
                  name="YouTube"
                  icon={<YouTubeIcon className="w-6 h-6" title="YouTube" />}
                />
              </Link>
              <Link
                href="https://www.linkedin.com/company/chatsystemai"
                target="_blank"
                rel="noreferrer"
              >
                <FooterLink
                  name="LinkedIn"
                  icon={<LinkedInIcon className="w-6 h-6" title="LinkedIn" />}
                />
              </Link>
              <Link
                href="mailto:yoann@chatsystem.ai"
                target="_blank"
                rel="noreferrer"
              >
                <FooterLink
                  name={emailUsTranslation}
                  icon={<EmailIcon className="w-6 h-6" title="Email" />}
                />
              </Link>
            </FooterLinkWrapper>
          </div>
          {/* <div className={`w-1/4 mb-8 lg:mb-0`}>
            <FooterCategoryName
              defaultMessage="Social"
              id="footer.tab.title.social"
            />
            <FooterLinkWrapper>
              <FooterLink name="RSS" />
              <FooterLink name="Rights" />
            </FooterLinkWrapper>
          </div> */}
        </div>
        <div className="mt-6 border-t pt-6">
          <FooterCategoryName
            defaultMessage="Articles"
            id="footer.tab.title.articles"
          />
          <div className="mt-6 border-t pt-6"></div>
          <FooterCategoryName
            defaultMessage="Chatbot"
            id="footer.tab.title.chatbot"
          />
          <FooterLinkWrapper>
            <Link
              href={`
                  /articles/${
                    ARTICLES_TO_DISPLAY.WHY_AGENTS_MATTER[appCurrentLang.locale]
                      .slug
                  }`}
            >
              <FooterLink
                name={
                  ARTICLES_TO_DISPLAY.WHY_AGENTS_MATTER[appCurrentLang.locale]
                    .title
                }
              />
            </Link>
          </FooterLinkWrapper>
          <FooterLinkWrapper>
            <Link
              href={`
                  /articles/${
                    ARTICLES_TO_DISPLAY.HOW_TO_IMPLEMENT[appCurrentLang.locale]
                      .slug
                  }`}
            >
              <FooterLink
                name={
                  ARTICLES_TO_DISPLAY.HOW_TO_IMPLEMENT[appCurrentLang.locale]
                    .title
                }
              />
            </Link>
          </FooterLinkWrapper>
          <div className="mt-6 border-t pt-6"></div>
          <FooterCategoryName
            defaultMessage="Data Augmentation"
            id="footer.tab.title.data_augmentation"
          />
          <FooterLinkWrapper>
            <Link
              href={`
                  /articles/${
                    ARTICLES_TO_DISPLAY.RETROGAMEPLACE_CASESTUDY[
                      appCurrentLang.locale
                    ].slug
                  }`}
            >
              <FooterLink
                name={
                  ARTICLES_TO_DISPLAY.RETROGAMEPLACE_CASESTUDY[
                    appCurrentLang.locale
                  ].title
                }
              />
            </Link>
          </FooterLinkWrapper>
        </div>
        <Copyright />
      </div>
    </div>
  );
};

export default Footer;
